import axios from "config/axios";
import { GenericPageResponse } from "shared/common";

export enum FileImportType {
  OTP_BANK_IMPORT = "OTP_BANK_IMPORT",
  MBH_BANK_IMPORT = "MBH_BANK_IMPORT",
  RECEIPT_SUMMARY_IMPORT = "RECEIPT_SUMMARY_IMPORT",
}

export enum FileImportStatus {
  ERROR = "ERROR",
  SUCCESS = "SUCCESS",
}

export interface FileImportLogEntry {
  id: number;
  tenantId: number;
  fileImportType: FileImportType;
  filename: string;
  importedAt: string;
  status: FileImportStatus;
}

const ENDPOINT = "/file-import-log";

export const getFileImportPage = (
  page: number,
  size: number,
  tenantId: number,
  search?: string,
  sort?: string,
) =>
  axios.get<GenericPageResponse<any>>(
    `${ENDPOINT}/get-page?page=${page}&size=${size}&tenantId=${tenantId}&search=${
      search || ""
    }&sort=${sort || ""}`,
  );
